var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212.85 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.59,58.05q9.38-2.27,16,3.46T54.22,77.6a31.71,31.71,0,0,1-6.63,19.29q-6.63,8.92-16,11.19l-17.78,4.29v-50ZM26.74,95l4.85-1.17A12,12,0,0,0,38.44,89a13.59,13.59,0,0,0,2.85-8.27,8.62,8.62,0,0,0-2.85-6.89,7.29,7.29,0,0,0-6.85-1.49l-4.85,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.87,44.22v50L75.94,97.37v-50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.2,69.39V90.07L93.27,93.19v-50L106.2,40l13.53,17.67a1.47,1.47,0,0,0,2.63-.9V36.14L135.29,33v50l-12.93,3.12L108.84,68.5A1.47,1.47,0,0,0,106.2,69.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.62,58.19V78.87L139.69,82V32l12.93-3.12L166.15,46.5a1.46,1.46,0,0,0,2.63-.89V24.93l12.93-3.12v50L168.78,75,155.26,57.29A1.47,1.47,0,0,0,152.62,58.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199,17.63v50l-12.93,3.12v-50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.13,82.27c-.51,2.16-1.33,4.43-.91,6.48.76,3.75,1.31,6.56.52,10.32-1.24,5.93-6.24,9.41-11.35,11.69C55,112.7,50.65,114.38,46.62,117s-6.43,6.29-6.11,11.13c0,.35.05.7.1,1.05-1.59-11.29,2.24-17.39,11.08-24.36,4-3.38,7.76-8.34,6.55-13.92a11.78,11.78,0,0,1-.05-5.54c.41-1.76,1.62-3.62,1.62-5.41,0-3.65-4.07-4.26-2.39-8.51C59,67.59,61.84,66.14,59,62.94,58,61.73,55.87,61,56.07,58.73c1.32-7.46,8.67-8.92,14.71-10.14,1.15-.28,1.74,1.11.93,2.22-3.19,4.43-4.11,5.72.23,9,2.84,3.2-.06,4.65-1.59,8.53-1.68,4.25,2.39,4.85,2.39,8.51C72.74,78.65,71.53,80.51,71.13,82.27Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 65.12,
    cy: 39.22,
    rx: 9.66,
    ry: 5.3,
    transform: "translate(-10.8 43.13) rotate(-34.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,119.24l30.15-7.32a11.61,11.61,0,0,1-2.34,6.82,10.27,10.27,0,0,1-5.65,4L0,130V51.38L45.9,40.3c4.42-1.07,8,2,8,6.9L8,58.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.85,0V78.62L83.94,109.74c-4.42,1.07-8-2-8-6.91L204.86,71.72v-61L75.94,41.88a11.62,11.62,0,0,1,2.34-6.81,10.22,10.22,0,0,1,5.66-3.95Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.831e287a5ad2957ee6fb73bd3acf1ca8.svg";
export { ForwardRef as ReactComponent };